import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/views/Home.vue'
import About from '@/views/About.vue'
import Contact from '@/views/Contact.vue'
import Service from '@/views/Service.vue'
import News from '@/views/News.vue'
import NewsDetail from '@/views/NewsDetail.vue'
import Industry from '@/views/Industry.vue'
import IndustryDetail from '@/views/IndustryDetail.vue'
import Cpic from '@/views/Cpic.vue'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => {
    if (err && err.name !== 'NavigationDuplicated') throw err
  })
}

export default new Router({
  mode: 'history',
  routes: [
    { path: '/', component: Home },
    { path: '/about', component: About },
    { path: '/contact', component: Contact },
    { path: '/service', component: Service },
    { path: '/products', redirect: '/industry' },
    { path: '/news', component: News },
    { path: '/news/:id', component: NewsDetail },
    { path: '/industry', component: Industry },
    { path: '/industry/:id', component: IndustryDetail },
    ...Array.from({ length: 20 }, (_, i) => {
      const id = i + 1
      return {
        path: `/bx${id}`,
        component: Cpic,
        meta: { hideLayout: true, cpicId: id }
      }
    })
  ],
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})
